module.exports = __webpack_public_path__ + "static/media/artificialIntelligence.a18f8c82.png";